import * as React from "react";
import axios, { AxiosResponse } from "axios";
import { MetricsType, Metrics, MetricsUnit, TimeFrame } from "./types";
import { useDispatch } from "./";
import { Sorting } from "../types";

export function useActions() {
  const dispatch = useDispatch();

  /**
   * Retrieves the detailed metrics data for the utilities
   */
  const getMetrics = React.useCallback(async function getMetrics(
    metricsType: MetricsType,
    sites: string[],
    startDate: string,
    endDate: string
  ) {
    dispatch({ type: "LOAD_METRICS" });
    try {
      const siteIds = [...new Set(sites)];
      const url = `/v1/metrics/sites/utilities`;
      const { data }: AxiosResponse<Metrics> = await axios.post(url, {
        siteIds,
        startDate,
        endDate,
        type: metricsType,
      });

      const metricsUnit = MetricsUnit[metricsType];
      dispatch({
        type: "METRICS_REQUEST_SUCCESS",
        metricsType,
        metricsUnit,
        metrics: data,
      });
    } catch (error) {
      // @TODO: Dispatch error state
    }
  },
  []);

  /**
   * Update selected time range for utilities metrics
   */
  const setTimeFrame = React.useCallback(function setTimeFrame(
    timeFrameOption: TimeFrame,
    startDate: string,
    endDate: string
  ) {
    dispatch({ type: "SET_TIME_FRAME", startDate, endDate, timeFrameOption });
  },
  []);

  /**
   * Set ordering of ranked sites chart (most to least || least to most)
   */
  const setRankedSitesSortingDirection = React.useCallback(
    function setSortDirection(value: Sorting) {
      dispatch({
        type: "SET_RANKED_SITES_SORTING_DIRECTION",
        rankedSites: value,
      });
    },
    []
  );

  /**
   * Set ordering of ranked years chart (latest to oldest || oldest to latest)
   */
  const setRankedYearsSortingDirection = React.useCallback(
    function setSortDirection(value: Sorting) {
      dispatch({
        type: "SET_RANKED_YEARS_SORTING_DIRECTION",
        rankedYears: value,
      });
    },
    []
  );

  /**
   * Update selected sites
   */
  const setSelectedSites = React.useCallback(function setSelectedSites(
    selectedSites: string[]
  ) {
    dispatch({
      type: "SET_SELECTED_SITES",
      selectedSites: [...new Set(selectedSites)],
    });
  },
  []);

  /**
   * Update currnet metrics type of utilities
   */
  const setMetricsType = React.useCallback(function SetMetricsType(
    metricsType: MetricsType
  ) {
    dispatch({ type: "SET_METRICS_TYPE", metricsType });
  },
  []);

  return {
    getMetrics,
    setTimeFrame,
    setMetricsType,
    setSelectedSites,
    setRankedSitesSortingDirection,
    setRankedYearsSortingDirection,
  };
}
